import { STATI } from "./stati";

export function isFixtureEvaluationFinalized(fixture) {
  return (
    fixture?.evaluation_finalized === true ||
    Number(fixture?.status) === Number(STATI.finalized) ||
    (
      fixture?.evaluation_operation?.state === "complete" &&
      fixture?.finalization?.reason === "evaluated"
    )
  );
}

export function isNormalCompileCandidate(
  fixture,
  { forceCompile = false, preMatch = false } = {},
) {
  return !isFixtureEvaluationFinalized(fixture) && (forceCompile || preMatch);
}
